module.exports = __webpack_public_path__ + "static/media/skill1.4ac02028.gif";